// removed by extract-text-webpack-plugin
module.exports = {"outer":"_31XX","heading":"_1oWZ","radio":"kYFZ","descrip":"_20yk"};


//////////////////
// WEBPACK FOOTER
// ./src/features/PhoneSystem/PhoneSystemForm/VpbxPlan/VpbxPlan.scss
// module id = iMQJ
// module chunks = 0